import {
  RemixiconComponentType,
  RiAccessibilityFill,
  RiAccountBoxFill,
  RiAddLargeFill,
  RiAi,
  RiAiAgentFill,
  RiAiGenerate2Fill,
  RiAlarmFill,
  RiAnchorFill,
  RiAndroidFill,
  RiAngularjsFill,
  RiAppleFill,
  RiArrowUpDoubleFill,
  RiAsterisk,
  RiAtomFill,
  RiAuctionFill,
  RiBankFill,
  RiBarChart2Fill,
  RiBarChartBoxFill,
  RiBardFill,
  RiBarricadeFill,
  RiBasketballFill,
  RiBatteryFill,
  RiBeerFill,
  RiBikeFill,
  RiBluetoothFill,
  RiBookFill,
  RiBookmarkFill,
  RiBookOpenFill,
  RiBookShelfFill,
  RiBowlFill,
  RiBox3Fill,
  RiBrainFill,
  RiBriefcase4Fill,
  RiBrush2Fill,
  RiBtcFill,
  RiBubbleChartFill,
  RiBugFill,
  RiBuilding3Fill,
  RiBusFill,
  RiCalculatorFill,
  RiCalendarFill,
  RiCameraAiFill,
  RiCameraFill,
  RiCapsuleFill,
  RiCashFill,
  RiCharacterRecognitionFill,
  RiChat3Fill,
  RiChatCheckFill,
  RiCheckboxCircleFill,
  RiCheckboxMultipleBlankFill,
  RiChessFill,
  RiChromeFill,
  RiCircleFill,
  RiClaudeFill,
  RiCloudFill,
  RiCompassFill,
  RiComputerFill,
  RiCopilotFill,
  RiCpuFill,
  RiCrosshairFill,
  RiCss3Fill,
  RiCurrencyFill,
  RiCursorFill,
  RiCustomerService2Fill,
  RiDatabase2Fill,
  RiDeepseekFill,
  RiDeleteBin5Fill,
  RiDice6Fill,
  RiDirectionFill,
  RiDiscordFill,
  RiDnaFill,
  RiDoorLockFill,
  RiDrinksFill,
  RiEarthFill,
  RiEdgeNewFill,
  RiEditFill,
  RiEmotionFill,
  RiEmotionHappyFill,
  RiEmotionLaughFill,
  RiEmotionNormalFill,
  RiEmotionUnhappyFill,
  RiEraserFill,
  RiErrorWarningFill,
  RiEthFill,
  RiExchange2Fill,
  RiFigmaFill,
  RiFileAi2Fill,
  RiFileEditFill,
  RiFileFill,
  RiFinderFill,
  RiFingerprint2Fill,
  RiFirebaseFill,
  RiFireFill,
  RiFirefoxFill,
  RiFirstAidKitFill,
  RiFlagFill,
  RiFlashlightFill,
  RiFlaskFill,
  RiFootballFill,
  RiFootprintFill,
  RiFundsBoxFill,
  RiGame2Fill,
  RiGamepadFill,
  RiGeminiFill,
  RiGiftFill,
  RiGithubFill,
  RiGitlabFill,
  RiGitMergeFill,
  RiGlobalFill,
  RiGlobeFill,
  RiGogglesFill,
  RiGooglePlayFill,
  RiGraduationCapFill,
  RiGroupFill,
  RiHeartFill,
  RiHeartPulseFill,
  RiHome4Fill,
  RiHotelBedFill,
  RiHourglassFill,
  RiHtml5Fill,
  RiImageFill,
  RiJavascriptFill,
  RiKeyFill,
  RiLandscapeFill,
  RiLayoutGrid2Fill,
  RiLeafFill,
  RiLightbulbFill,
  RiLockFill,
  RiMacbookFill,
  RiMagicFill,
  RiMailFill,
  RiMap2Fill,
  RiMapPinFill,
  RiMedalFill,
  RiMegaphoneFill,
  RiMessageFill,
  RiMicFill,
  RiMixtralFill,
  RiMoneyDollarCircleFill,
  RiMoneyEuroCircleFill,
  RiMoonClearFill,
  RiMusic2Fill,
  RiNextjsFill,
  RiNodejsFill,
  RiNodeTree,
  RiNotification3Fill,
  RiNotificationFill,
  RiNotionFill,
  RiOpenaiFill,
  RiPaintBrushFill,
  RiPaintFill,
  RiPantoneFill,
  RiPencilAiFill,
  RiPencilRuler2Fill,
  RiPhoneFill,
  RiPieChartFill,
  RiPingPongFill,
  RiPlaneFill,
  RiPlugFill,
  RiPriceTagFill,
  RiPrinterFill,
  RiQuestionAnswerFill,
  RiQuestionMark,
  RiQuillPenFill,
  RiRadarFill,
  RiRadioFill,
  RiReactjsFill,
  RiRecycleFill,
  RiRoadsterFill,
  RiRobot2Fill,
  RiRocket2Fill,
  RiRouteFill,
  RiRouterFill,
  RiRunFill,
  RiSailboatFill,
  RiSaveFill,
  RiScissorsFill,
  RiSearchFill,
  RiServerFill,
  RiSettings5Fill,
  RiShieldStarFill,
  RiShoppingBagFill,
  RiShoppingCartFill,
  RiSignalTowerFill,
  RiSignpostFill,
  RiSketching,
  RiSkullFill,
  RiSlackFill,
  RiSmartphoneFill,
  RiSpeakerFill,
  RiSpeedUpFill,
  RiSpyFill,
  RiStairsFill,
  RiStarFill,
  RiStoreFill,
  RiSubwayFill,
  RiSunFill,
  RiSupabaseFill,
  RiSurgicalMaskFill,
  RiSvelteFill,
  RiSwordFill,
  RiTableFill,
  RiTabletFill,
  RiTapeFill,
  RiTargetFill,
  RiTaxiFill,
  RiTerminalBoxFill,
  RiTextBlock,
  RiTextSnippet,
  RiTextToSpeechFill,
  RiThumbDownFill,
  RiThumbUpFill,
  RiThunderstormsFill,
  RiTimeFill,
  RiToggleFill,
  RiTrafficLightFill,
  RiTrainFill,
  RiTreeFill,
  RiTruckFill,
  RiTShirtFill,
  RiUmbrellaFill,
  RiVerifiedBadgeFill,
  RiVideoFill,
  RiVipCrown2Fill,
  RiVolumeMuteFill,
  RiVolumeUpFill,
  RiVuejsFill,
  RiWindowFill,
  RiWrenchFill,
} from "@remixicon/react";

import BuBurger from "@/common/assets/burger.svg?react";
import BuExtinguisher from "@/common/assets/extinguisher.svg?react";
import BuFlag from "@/common/assets/flag-fill.svg?react";
import BuLadder from "@/common/assets/ladder.svg?react";
import BuLinearLogo from "@/common/assets/linear-logo.svg?react";
import BuMagnet from "@/common/assets/magnet.svg?react";
import BuPizza from "@/common/assets/pizza.svg?react";
import { CustomIconKey } from "@reflag/shared/icons";

function customIconWrapper(
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
): RemixiconComponentType {
  // eslint-disable-next-line react/display-name
  return ({ size, ...rest }) => <Icon height={size} width={size} {...rest} />;
}

export const CustomIconMap: Record<CustomIconKey, RemixiconComponentType> = {
  Default: customIconWrapper(BuFlag),
  Project: RiBox3Fill,
  Issue: RiCheckboxMultipleBlankFill,
  // AI & Machine Learning
  Ai: RiAi,
  AiAgent: RiAiAgentFill,
  AiDocument: RiFileAi2Fill,
  AiGenerate: RiAiGenerate2Fill,
  AiWriting: RiPencilAiFill,
  CameraAi: RiCameraAiFill,
  CharacterRecognition: RiCharacterRecognitionFill,
  Robot: RiRobot2Fill,
  Bard: RiBardFill,
  Claude: RiClaudeFill,
  Copilot: RiCopilotFill,
  Deepseek: RiDeepseekFill,
  Gemini: RiGeminiFill,
  Mixtral: RiMixtralFill,
  Openai: RiOpenaiFill,
  // Tech Brands & Platforms
  Android: RiAndroidFill,
  Apple: RiAppleFill,
  GooglePlay: RiGooglePlayFill,
  Chrome: RiChromeFill,
  Edge: RiEdgeNewFill,
  Firefox: RiFirefoxFill,
  Finder: RiFinderFill,
  Mac: RiMacbookFill,
  Css3: RiCss3Fill,
  Html5: RiHtml5Fill,
  Javascript: RiJavascriptFill,
  Angularjs: RiAngularjsFill,
  Nextjs: RiNextjsFill,
  Nodejs: RiNodejsFill,
  Reactjs: RiReactjsFill,
  Svelte: RiSvelteFill,
  Vuejs: RiVuejsFill,
  Firebase: RiFirebaseFill,
  Supabase: RiSupabaseFill,
  Discord: RiDiscordFill,
  Figma: RiFigmaFill,
  Github: RiGithubFill,
  Gitlab: RiGitlabFill,
  Linear: customIconWrapper(BuLinearLogo),
  Notion: RiNotionFill,
  Slack: RiSlackFill,
  // Programming & Development
  Bug: RiBugFill,
  Cloud: RiCloudFill,
  CpuChip: RiCpuFill,
  Database: RiDatabase2Fill,
  Merge: RiGitMergeFill,
  NodeTree: RiNodeTree,
  Server: RiServerFill,
  Terminal: RiTerminalBoxFill,
  // Finance & Commerce
  Bank: RiBankFill,
  CurrencyStack: RiCurrencyFill,
  DollarBill: RiCashFill,
  DollarCircle: RiMoneyDollarCircleFill,
  EuroCircle: RiMoneyEuroCircleFill,
  Bitcoin: RiBtcFill,
  Ethereum: RiEthFill,
  FundsChart: RiFundsBoxFill,
  PriceTag: RiPriceTagFill,
  // Charts & Analytics
  BarChart: RiBarChart2Fill,
  BubbleChart: RiBubbleChartFill,
  Calendar: RiCalendarFill,
  Dashboard: RiBarChartBoxFill,
  Dial: RiSpeedUpFill,
  PieChart: RiPieChartFill,
  // Communication
  ChatBubble: RiChat3Fill,
  ChatCheck: RiChatCheckFill,
  Message: RiMessageFill,
  QuestionAnswer: RiQuestionAnswerFill,
  Email: RiMailFill,
  Megaphone: RiMegaphoneFill,
  Microphone: RiMicFill,
  Phone: RiPhoneFill,
  Speaker: RiSpeakerFill,
  TextToSpeech: RiTextToSpeechFill,
  Video: RiVideoFill,
  // Nature & Weather
  Earth: RiEarthFill,
  Fire: RiFireFill,
  Leaf: RiLeafFill,
  Moon: RiMoonClearFill,
  Sun: RiSunFill,
  Thunderstorm: RiThunderstormsFill,
  Tree: RiTreeFill,
  Umbrella: RiUmbrellaFill,
  // Transportation
  Airplane: RiPlaneFill,
  Sailboat: RiSailboatFill,
  Bike: RiBikeFill,
  Car: RiRoadsterFill,
  Taxi: RiTaxiFill,
  Truck: RiTruckFill,
  Bus: RiBusFill,
  Subway: RiSubwayFill,
  Train: RiTrainFill,
  // Sports & Games
  Basketball: RiBasketballFill,
  PingPong: RiPingPongFill,
  Runner: RiRunFill,
  SoccerBall: RiFootballFill,
  ChessTower: RiChessFill,
  Dice: RiDice6Fill,
  Game: RiGame2Fill,
  Gamepad: RiGamepadFill,
  // Design & Creative
  Brush: RiBrush2Fill,
  DesignTools: RiPencilRuler2Fill,
  Eraser: RiEraserFill,
  PaintBrush: RiPaintBrushFill,
  PaintBucket: RiPaintFill,
  Pantone: RiPantoneFill,
  Scissors: RiScissorsFill,
  Signature: RiSketching,
  // Files & Documents
  Book: RiBookFill,
  Bookmark: RiBookmarkFill,
  BookOpen: RiBookOpenFill,
  BookShelf: RiBookShelfFill,
  File: RiFileFill,
  FileEdit: RiFileEditFill,
  FloppyDisk: RiSaveFill,
  // Security & Access
  DoorLock: RiDoorLockFill,
  FaceId: RiAccountBoxFill,
  Fingerprint: RiFingerprint2Fill,
  Key: RiKeyFill,
  Lock: RiLockFill,
  StarShield: RiShieldStarFill,
  Verified: RiVerifiedBadgeFill,
  // UI & Interface Elements
  Accessibility: RiAccessibilityFill,
  Alert: RiErrorWarningFill,
  ArrowUpDouble: RiArrowUpDoubleFill,
  Asterisk: RiAsterisk,
  BellSubscribe: RiNotification3Fill,
  CheckCircle: RiCheckboxCircleFill,
  Circle: RiCircleFill,
  Cross: RiAddLargeFill,
  Crosshair: RiCrosshairFill,
  Cursor: RiCursorFill,
  Edit: RiEditFill,
  Grid: RiLayoutGrid2Fill,
  Notification: RiNotificationFill,
  QuestionMark: RiQuestionMark,
  Search: RiSearchFill,
  Settings: RiSettings5Fill,
  Toggle: RiToggleFill,
  Window: RiWindowFill,
  // E-commerce
  ShoppingBag: RiShoppingBagFill,
  ShoppingCart: RiShoppingCartFill,
  Store: RiStoreFill,
  // Location & Navigation
  Compass: RiCompassFill,
  Direction: RiDirectionFill,
  Global: RiGlobalFill,
  Globe: RiGlobeFill,
  Landscape: RiLandscapeFill,
  Map: RiMap2Fill,
  MapPin: RiMapPinFill,
  Radar: RiRadarFill,
  Route: RiRouteFill,
  Router: RiRouterFill,
  Signpost: RiSignpostFill,
  // Emotions & Reactions
  EmotionHappy: RiEmotionHappyFill,
  EmotionLaugh: RiEmotionLaughFill,
  EmotionNormal: RiEmotionNormalFill,
  EmotionUnhappy: RiEmotionUnhappyFill,
  EmotionVeryHappy: RiEmotionFill,
  Heart: RiHeartFill,
  HeartPulse: RiHeartPulseFill,
  ThumbDown: RiThumbDownFill,
  ThumbUp: RiThumbUpFill,
  // Food & Drinks
  Beer: RiBeerFill,
  Burger: customIconWrapper(BuBurger),
  Bowl: RiBowlFill,
  Coffee: RiDrinksFill,
  Pizza: customIconWrapper(BuPizza),
  // Medical & Health
  Extinguisher: customIconWrapper(BuExtinguisher),
  FirstAidKit: RiFirstAidKitFill,
  Pills: RiCapsuleFill,
  SurgicalMask: RiSurgicalMaskFill,
  // Household & Objects
  Alarm: RiAlarmFill,
  Anchor: RiAnchorFill,
  Atom: RiAtomFill,
  Battery: RiBatteryFill,
  Bed: RiHotelBedFill,
  Bluetooth: RiBluetoothFill,
  Briefcase: RiBriefcase4Fill,
  Calculator: RiCalculatorFill,
  Camera: RiCameraFill,
  Crown: RiVipCrown2Fill,
  Feather: RiQuillPenFill,
  Flag: RiFlagFill,
  Flashlight: RiFlashlightFill,
  Flask: RiFlaskFill,
  Gift: RiGiftFill,
  Hourglass: RiHourglassFill,
  Image: RiImageFill,
  Ladder: customIconWrapper(BuLadder),
  LightBulb: RiLightbulbFill,
  MagicWand: RiMagicFill,
  Magnet: customIconWrapper(BuMagnet),
  Medal: RiMedalFill,
  Plug: RiPlugFill,
  Printer: RiPrinterFill,
  Radio: RiRadioFill,
  Recycle: RiRecycleFill,
  Rocket: RiRocket2Fill,
  Skull: RiSkullFill,
  Star: RiStarFill,
  Table: RiTableFill,
  Tablet: RiTabletFill,
  Tape: RiTapeFill,
  Target: RiTargetFill,
  TShirt: RiTShirtFill,
  VrGoggles: RiGogglesFill,
  Wrench: RiWrenchFill,
  // Buildings & Places
  Factory: RiBuilding3Fill,
  GraduationCap: RiGraduationCapFill,
  Home: RiHome4Fill,
  // Actions & Symbols
  Exchange: RiExchange2Fill,
  Gavel: RiAuctionFill,
  Trash: RiDeleteBin5Fill,
  // Entertainment & Media
  MusicNote: RiMusic2Fill,
  VolumeMute: RiVolumeMuteFill,
  VolumeUp: RiVolumeUpFill,
  // Technology & Hardware
  Computer: RiComputerFill,
  SignalTower: RiSignalTowerFill,
  Smartphone: RiSmartphoneFill,
  // Miscellaneous
  Anonymous: RiSpyFill,
  Brain: RiBrainFill,
  CustomerService: RiCustomerService2Fill,
  Dna: RiDnaFill,
  Footprint: RiFootprintFill,
  Group: RiGroupFill,
  Stairs: RiStairsFill,
  Sword: RiSwordFill,
  TextBlock: RiTextBlock,
  TextSnippet: RiTextSnippet,
  Time: RiTimeFill,
  TrafficCone: RiBarricadeFill,
  TrafficLight: RiTrafficLightFill,
} as const;
